import { observer } from 'mobx-react-lite'

import type { VoiceAnalyticsCallQualityPayload } from '@src/service/analytics/VoiceAnalyticsStore'

import ConnectedCallQualityWizard from './ConnectedCallQualityWizard'
import type { EffectiveConnectionType } from './NetworkInformationUiStore'
import * as styles from './ongoing-call/OngoingCall.css'

interface CallQualityWizardDialog {
  call: VoiceAnalyticsCallQualityPayload
  networkInformation: {
    connectionType: string
    effectiveConnectionType: EffectiveConnectionType
  }
  appVersion: string
}

function CallQualityWizardDialog({
  call,
  networkInformation,
  appVersion,
}: CallQualityWizardDialog) {
  if (typeof call.endedAt !== 'number') {
    throw new Error(
      'CallQualityWizardDialog should only be rendered after the call has ended',
    )
  }
  return (
    <div role="dialog" aria-label="Rate the call quality" className={styles.root}>
      <div className={styles.leftPanel}>
        <ConnectedCallQualityWizard
          call={call}
          endedAt={call.endedAt}
          networkInformation={networkInformation}
          appVersion={appVersion}
        />
      </div>
    </div>
  )
}

export default observer(CallQualityWizardDialog)
